import { SALESFORCE_LIGHTNING_INDICATORS_BY_CONTEXT_TYPE } from './indicators/salesforceIndicators';
export const getSalesforcePageListeners = context => ({
    selectors: {
        highlightsAndRecords: ['.windowViewMode-normal.oneContent.active.lafPageHost'],
    },
    indicatorIterations: {
        numOfIterations: 20,
        millisPerIteration: 1000,
    },
    observers: {
        recordDetailsComponent: ['.windowViewMode-normal.oneContent.active.lafPageHost'],
        findComponentValue: ['[data-component-id="force_detailPanel"]'],
    },
    indicators: {
        salesforceClassicIndicator: ['#contactHeaderRow'],
        salesforceLightningIndicators: SALESFORCE_LIGHTNING_INDICATORS_BY_CONTEXT_TYPE[context],
    },
});
